import { axiosFactory } from './axiosFactory'

export const axiosCoverageJWT = axiosFactory.getAxios('coverageJWT')
